export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-color/src/math.js
// module id = slvu
// module chunks = 0